import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import AnimatedRoute from '../components/AnimatedRoute';
import { localStorageSave } from '../utils/localStorageHelper';
import withTracker from '../wrappers/withTracker';
import Button from '../components/Button';
import { userGenderSubmitEvent } from '../actions/segment';

function Sex({ userGenderSubmitEvent }) {
  const [animationDirection, setAnimationDirection] = useState('mount'); // mount, back, forward

  async function handleNext(selection) {
    // store info in redux;
    // animate and transition
    localStorageSave('gender', selection);
    userGenderSubmitEvent();
    setAnimationDirection('unmount');
  }
  return (
    <AnimatedRoute
      nextRoute='/birthdate'
      title='What’s your legal sex?'
      animationDirection={animationDirection}
      setAnimationDirection={setAnimationDirection}
    >
      <PContainer>
        <Paragraph>
          We need this for health insurance purposes. You’ll get a chance to
          tell us your gender identity later.
        </Paragraph>
      </PContainer>

      <ButtonsContainer>
        <ButtonCotainer>
          <CTAButton className='cta-button' onClick={() => handleNext('male')}>
            Male
          </CTAButton>
        </ButtonCotainer>

        <ButtonCotainer>
          <CTAButton
            className='cta-button'
            onClick={() => handleNext('female')}
          >
            Female
          </CTAButton>
        </ButtonCotainer>
      </ButtonsContainer>
    </AnimatedRoute>
  );
}

const ButtonCotainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: inherit;
  & ${Button} button {
    width: 100%;
  }
  @media only screen and (min-width: 769px) {
    ${Button} button {
      width: 240px;
    }
  }
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  & ${ButtonCotainer}:not(:last-child) {
    margin-bottom: 24px;
  }
  @media only screen and (min-width: 769px) {
    flex-direction: row;
    & ${ButtonCotainer}:not(:last-child) {
      margin-right: 24px;
      margin-bottom: 0;
    }
  }
`;

const CTAButton = styled(Button)`
  &.cta-button {
    width: 100%;
  }
  @media only screen and (min-width: 769px) {
    &.cta-button {
      width: 240px;
    }
  }
`;

const PContainer = styled.div`
  display: flex;
  max-width: 100%;
  flex: 1;
  @media only screen and (min-width: 769px) {
    margin-bottom: 42px;
    flex: 0;
  }
`;

const Paragraph = styled.p`
  font-family: 'Usual';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04em;
  color: #66727f;
`;

export default connect(null, {
  userGenderSubmitEvent,
})(withTracker(Sex, 'Signup - Sex - Page View'));
